import { createSlice } from "@reduxjs/toolkit"

export const authSlice = createSlice({
    name: 'auth',
    initialState: {
        clientsData: null,
        authData: null,
        domainName: null
    },
    reducers: {
        setAuthData: (state, action) => {
            state.authData = action.payload.authData;
            state.clientsData = action.payload.clientsData;
        },
        setDomainName: (state, action) => {
            state.domainName = action.payload.domainName;
        },
        clearAuthData: (state) => {
            state.authData = null;
            state.clientsData = null;
            state.domainName = null;
        }
    }
});



export const { setAuthData, setDomainName, clearAuthData } = authSlice.actions;
export const selectAuthData = (state) => state.auth;

export default authSlice.reducer;